export default __webpack_public_path__ + "19beddcda9ca3c9ab433e06eba0a0de7.png";